export function newId() {
	// First character is an 'a', it's good practice to tag id to begin with a letter
	return 'axxxxxxxxxxx'.replace(/[x]/g, _ => {
		// tslint:disable-next-line:no-bitwise
		const val = (Math.random() * 16) | 0;
		return val.toString(16);
	});
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/libs/@ng-select/ng-select/id.ts